export class ChildBirthFacility {
    public static readonly CHILD_BIRTH_WITHOUT_HELP = new ChildBirthFacility ("ChildBirthWithoutHelp" , "Parto sem auxílio");
    public static readonly CHILD_BIRTH_WITH_EASY_TRACTION = new ChildBirthFacility ("ChildBirthWithEasyTraction", "Parto com tração fácil");
    public static readonly CHILD_BIRTH_WITH_HARD_TRACTION = new ChildBirthFacility ("ChildBirthWithHardTraction", "Parto com tração difícil");
    public static readonly CHILD_BIRTH_WITH_SURGERY = new ChildBirthFacility ("ChildBirthWithSurgery", "Parto com cirurgia");
    public static readonly CHILD_BIRTH_WITH_BAD_PRESENTATION = new ChildBirthFacility ("ChildBirthWithBadPresentation", "Parto com má apresentação");

    public constructor(
        public readonly name: string,
        public readonly label: string
    ) { }

    public static values(): ChildBirthFacility[] {
        return [
            ChildBirthFacility.CHILD_BIRTH_WITHOUT_HELP,
            ChildBirthFacility.CHILD_BIRTH_WITH_EASY_TRACTION,
            ChildBirthFacility.CHILD_BIRTH_WITH_HARD_TRACTION,
            ChildBirthFacility.CHILD_BIRTH_WITH_SURGERY,
            ChildBirthFacility.CHILD_BIRTH_WITH_BAD_PRESENTATION,
        ];
    }

    public static get(name: string): ChildBirthFacility {
        const type = ChildBirthFacility.values().find((it) => it.name === name);
        if (type == null) {
            throw new Error(`${name} is not a mapped Facility.`);
        };
        return type;
    }
}
